import { DeviceCurrentState } from '@types';
export interface AppConfig {
  stateOptions?: Array<{ value: string; label: string }>;
  defaultLevel?: string;
  defaultVariation: number;
  defaultDuration?: number;
  hasLevel?: boolean;
  hasVariation?: boolean;
  hasDuration?: boolean;
  requiresBaseline?: boolean;
  devices?: {
    vr: boolean;
    sensor: boolean;
  };
}
export type AppConfigDeviceRequirements = {
  vr: boolean;
  sensor: boolean;
};

export const appConfigs: Record<string, AppConfig> = {
  performance: {
    stateOptions: [
      { value: 'p-2', label: 'P-2' },
      { value: 'p-1', label: 'P-1' },
      { value: 'p0', label: 'P0' },
      { value: 'p1', label: 'P+1' },
      { value: 'p2', label: 'P+2' },
    ] as Array<{ value: DeviceCurrentState; label: string }>,
    defaultLevel: 'p-2',
    defaultVariation: 5,
    defaultDuration: 300,
    hasLevel: true,
    hasVariation: true,
    hasDuration: true,
    requiresBaseline: true,
    devices: {
      vr: true,
      sensor: true,
    },
  },
  wellbeing: {
    defaultDuration: 600,
    defaultVariation: 0,
    hasDuration: true,
    requiresBaseline: false,
    devices: {
      vr: true,
      sensor: false,
    },
  },
  psychology: {
    defaultDuration: 600,
    defaultVariation: 0,
    hasDuration: true,
    devices: {
      vr: true,
      sensor: false,
    },
  },
  corporate: {
    defaultDuration: 600,
    defaultVariation: 0,
    hasDuration: true,
    devices: {
      vr: true,
      sensor: false,
    },
  },
  situations: {
    defaultDuration: 600,
    hasDuration: true,
    defaultVariation: 0,
    devices: {
      vr: true,
      sensor: false,
    },
  },
  mentalization: {
    defaultDuration: 600,
    defaultVariation: 0,
    hasDuration: true,
    devices: {
      vr: true,
      sensor: false,
    },
  },
  exposure: {
    defaultDuration: 300,
    defaultVariation: 0,
    hasLevel: false,
    hasVariation: false,
    hasDuration: true,
    requiresBaseline: false,
    devices: {
      vr: true,
      sensor: false,
    },
  },
  body_image: {
    defaultDuration: 300,
    defaultVariation: 0,
    hasLevel: false,
    hasVariation: false,
    hasDuration: false,
    requiresBaseline: false,
    devices: {
      vr: true,
      sensor: false,
    },
  },
  default: {
    defaultDuration: 600,
    defaultVariation: 0,
    hasDuration: true,
    devices: {
      vr: true,
      sensor: false,
    },
  },
};

export const getAppConfig = (appType: string): AppConfig => {
  return appConfigs[appType] || appConfigs.default;
};
